export const ContractRegistry = {
  '8453': {
    Oracles: {
      ReferenceAssetOracle: '0x3a542a27002D4494CEd5512C78e69E0E8dc8B715',
      Uniswapv3Oracle: '0x76b65d87b8FD10a33dB264c3CC5D03ebcbee675D',
      spot: '0xd290a5Cb64938911EaD3eB5cBe2A0B5c93a0B62e',
    },
    NativeWrapperToken: {
      address: '0xd07379a755A8f11B57610154861D694b2A0f615a',
      decimals: 18,
    },
    DefaultStableToken: {
      address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      decimals: 6,
    },
  },
  '31438': {
    isTestnet: false,
    Oracles: {
      spot: '0xd290a5Cb64938911EaD3eB5cBe2A0B5c93a0B62e',
      ReferenceAssetOracle: '',
      Uniswapv3Oracle: '',
    },
    NativeWrapperToken: {
      address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      decimals: 18,
    },
    DefaultStableToken: {
      address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      decimals: 6,
    },
  },
  '1': {
    isTestnet: false,
    Oracles: {
      ReferenceAssetOracle: '',
      Uniswapv3Oracle: '0x2ff594F29610d25C124068254a054ce95c24cce0',
      spot: '',
    },
    NativeWrapperToken: {
      address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      decimals: 18,
    },
    DefaultStableToken: {
      address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      decimals: 6,
    },
  },
} as const;
